// extracted by mini-css-extract-plugin
export default {"center":"WhvZ1VtT","brand":"mFLbu0Mg","glyph":"OwM61eB7","name":"N1BRnICM","title":"Z2JsQVDj","body":"gSpixJ2J"};